import { AnyAction, combineReducers, Reducer, ReducersMapObject } from "redux";

import { changeCompany } from "@/store/features/companies/companies";

import appReducer, { AppState } from "./app/app";
import crudReducer, { CrudState } from "./crud";
import dataReducer, { DataState } from "./data/data";
import featuresReducer, { FeaturesState } from "./features/featuresReducer";
import entityNavigationReducer, {
  EntityNavigationState
} from "./navigation/entityNavigation";
import pageReducer, { PageState } from "./page/page";
import queriesReducer, { QueriesState } from "./queries/queries";

export interface RootState {
  app: AppState;
  crud: CrudState;
  features: FeaturesState;
  data: DataState;
  page: PageState;
  queires: QueriesState;
  entityNavigation: EntityNavigationState;
}

export interface LazyState {}

const staticReducers: ReducersMapObject<Omit<RootState, "lazy">> = {
  app: appReducer,
  crud: crudReducer,
  features: featuresReducer,
  data: dataReducer,
  page: pageReducer,
  queires: queriesReducer,
  entityNavigation: entityNavigationReducer
};

// const emptyLazyReducer = (state: LazyState | undefined) => state ?? {};

const createRootReducer = (): Reducer<RootState> => {
  const rootReducerMap: ReducersMapObject<RootState> = {
    ...staticReducers
  };
  const rootReducer = combineReducers(rootReducerMap);

  return (currentState: RootState | undefined, action: AnyAction) => {
    // When we are changing company, we want to do a mass reset of all slices, with a
    // couple of exceptions, so that users don't see any cross-company data.
    if (currentState && action.type === changeCompany.type) {
      const initialState = rootReducer(undefined, action);
      return {
        ...initialState,
        // We want to keep the app state the same, but apply the `changeCompany` action so it
        // can handle its own resetting as needed.Company
        app: appReducer(currentState.app, action)
      };
    }

    return rootReducer(currentState, action);
  };
};

export default createRootReducer;
